import React from 'react';
import { Sparkles } from 'lucide-react';
import { colors } from '../../theme/colors';

const ImportSection = ({
  fieldImportText,
  setFieldImportText,
  importingFields,
  setShowImportSection,
  handleImportFields
}) => {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      height: '100%', // Use all available space from parent
      gap: '0.75rem' 
    }}>
      <textarea
        placeholder={`Paste field names here

Examples:
• Borrower Name
• Loan Amount
• Interest Rate
• Property Address`}
        style={{
          width: '100%',
          flex: 1, // Grow to fill available space
          minHeight: '200px', // Minimum height
          padding: '0.75rem',
          background: 'rgba(255, 255, 255, 0.05)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '6px',
          color: '#e0e0e0',
          fontSize: '0.875rem',
          resize: 'none', // Disable resize since flexbox handles sizing
          fontFamily: 'inherit',
          outline: 'none',
          scrollbarWidth: 'thin',
          scrollbarColor: '#4a4a4a transparent'
        }}
        value={fieldImportText}
        onChange={(e) => setFieldImportText(e.target.value)}
      />
      
      <div style={{ 
        display: 'flex', 
        gap: '0.75rem', 
        flexShrink: 0, // Don't shrink buttons
        paddingTop: '0.75rem' // Add some top padding
      }}>
        <button
          onClick={() => {
            setShowImportSection(false);
            setFieldImportText('');
          }}
          style={{
            padding: '1rem 1.5rem',
            background: 'transparent',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '6px',
            color: '#a0a0a0',
            fontSize: '0.875rem',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.2s',
            outline: 'none'
          }}
        >
          Cancel
        </button>
        <button
          onClick={handleImportFields}
          disabled={!fieldImportText.trim() || importingFields}
          style={{
            flex: 1,
            padding: '1rem 1.5rem',
            background: (fieldImportText.trim() && !importingFields) ? colors.primary : 'rgba(255, 255, 255, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '6px',
            color: (fieldImportText.trim() && !importingFields) ? '#ffffff' : '#a0a0a0',
            fontSize: '0.875rem',
            fontWeight: '500',
            cursor: (fieldImportText.trim() && !importingFields) ? 'pointer' : 'not-allowed',
            transition: 'all 0.2s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            outline: 'none'
          }}
        >
          <Sparkles size={16} />
          {importingFields ? 'Processing...' : 'Process'}
        </button>
      </div>
    </div>
  );
};

export default ImportSection;
